:host {
  display: inline-block;
}
:host slot {
  display: inline-flex;
  position: relative;
  white-space: nowrap;
  vertical-align: top;
}
:host([tabs]) {
  display: block;
}
:host([tabs]) slot {
  display: flex;
}
:host([tabs]) ::slotted(*) {
  flex: 1 0;
}
